/**
 * Centralized environment variable configuration.
 * Validates required env vars at startup and provides typed access.
 */

function getEnvVar(key: string, fallback?: string): string {
    const value = import.meta.env[key] ?? fallback;
    if (value === undefined) {
        throw new Error(
            `Missing required environment variable: ${key}. Check your .env file.`
        );
    }
    return value;
}

export const env = {
    /** Base URL for the backend API */
    API_BASE_URL: getEnvVar("VITE_API_BASE_URL", "http://127.0.0.1:8000"),
} as const;
